"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var BoxSemiTrailerMove = function BoxSemiTrailerMove(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 58.5 20.7",
    width: "58.5",
    height: "20.7"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M58.1,16.3h-5.2c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4h4.8V0.8H0.8v12.7l7,2h21.5c0.2,0,0.4,0.2,0.4,0.4 s-0.2,0.4-0.4,0.4H7.7c0,0-0.1,0-0.1,0l-7.3-2.1C0.1,14.2,0,14,0,13.8V0.4C0,0.2,0.2,0,0.4,0h57.7c0.2,0,0.4,0.2,0.4,0.4v15.5 C58.5,16.2,58.3,16.3,58.1,16.3z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M4.1,20.7c-0.3,0-0.5-0.2-0.5-0.5v-5c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v5C4.6,20.4,4.4,20.7,4.1,20.7 z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M41,20.4c-1.7,0-3.1-1.4-3.1-3.1s1.4-3.1,3.1-3.1s3.1,1.4,3.1,3.1S42.7,20.4,41,20.4z M41,15 c-1.3,0-2.3,1-2.3,2.3c0,1.3,1,2.3,2.3,2.3s2.3-1,2.3-2.3C43.3,16,42.3,15,41,15z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M48.5,20.4c-1.7,0-3.1-1.4-3.1-3.1s1.4-3.1,3.1-3.1s3.1,1.4,3.1,3.1S50.2,20.4,48.5,20.4z M48.5,15 c-1.3,0-2.3,1-2.3,2.3c0,1.3,1,2.3,2.3,2.3s2.3-1,2.3-2.3C50.8,16,49.8,15,48.5,15z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M33.5,20.4c-1.7,0-3.1-1.4-3.1-3.1s1.4-3.1,3.1-3.1s3.1,1.4,3.1,3.1S35.2,20.4,33.5,20.4z M33.5,15 c-1.3,0-2.3,1-2.3,2.3c0,1.3,1,2.3,2.3,2.3s2.3-1,2.3-2.3C35.8,16,34.8,15,33.5,15z"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    fill: "#9ECE06",
    points: "37.4,13.9 37.4,1.7 47.6,7.8     "
  }));
};

var _default = BoxSemiTrailerMove;
exports["default"] = _default;